import React from 'react'

const ConcoursAffiche = () => {
  return (
    <div>
      <h1>CONCOURS D'AFFICHES POUR LES 20 ANS DE BDLA !</h1>
      <p>
        Le festival BIARD dans les Airs (BDLA) fêtera ses 20 ans en juin 2027.
        Oui, l’année prochaine !
      </p>
      <p>
        Notre association aimerait faire participer les habitants de Biard et
        alentours à cet événement festif en organisant deux concours d’affiches.
      </p>
      <p>
        CONCOURS D'AFFICHES POUR LES 20 ANS DE BDLA ! Le festival BIARD dans les
        Airs (BDLA) fêtera ses 20 ans en juin 2027. Oui, l’année prochaine !
        Notre association aimerait faire participer les habitants de Biard et
        alentours à cet événement festif en organisant deux concours d’affiches.
        Vous trouverez ici toutes les informations concernant le concours
        d’affiches des enfants ainsi que celles concernant le concours des
        adultes.
      </p>
      <p>
        Les inscriptions sont à faire avant le 1er mai 2026 à l’adresse mail :{' '}
        <a href="mailto:clavalette@laposte.net">clavalette@laposte.net</a>
      </p>
      <p>
        Les affiches réalisées sont à déposer au secrétariat de la mairie de
        Biard avant le 15 juin 2026.
      </p>
      <p>
        Toutes les affiches seront exposées pendant le festival BDLA de juin
        2026.
      </p>
      <p>
        Un jury sélectionnera une affiche parmi celle des enfants et une parmi
        celles des adultes qui serviront de support de communication pour le
        festival des 20 ans en juin 2027.
      </p>
      <p>
        Pour toutes informations complémentaires vous pouvez vous adresser par
        mail à l’adresse :{' '}
        <a href="mailto:clavalette@laposte.net">clavalette@laposte.net</a>
      </p>
      <p>Merci pour votre participation !</p>
      <p>Les co-président.e.s de l’association BDLA.</p>
      <a href="./Concours adultes.pdf" target="_blank">
        Règlement du concours adultes
      </a>{' '}
      |{' '}
      <a href="./concours enfants.pdf" target="_blank">
        Règlement du concours enfants
      </a>
    </div>
  )
}

export default ConcoursAffiche
